import { CheckCircle2, History, XCircle } from 'lucide-react'
import { useEffect, useState } from 'react'
import { api } from '../api/client'
import { PageTitle } from '../components/PageTitle'
import type { AuditLog } from '../types'

export function AuditPage() {
  const [items, setItems] = useState<AuditLog[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    void api<{ items: AuditLog[] }>('/audit?limit=100').then((data) => setItems(data.items || [])).finally(() => setLoading(false))
  }, [])

  return (
    <div className="page-stack">
      <PageTitle icon={<History size={22} />} title="操作记录" description="记录管理员对员工、群邮箱和公共邮箱的关键操作。" />
      <section className="panel table-panel">
        <div className="table-wrap">
          <table>
            <thead><tr><th>结果</th><th>操作</th><th>对象</th><th>详情</th><th>管理员</th><th>时间</th></tr></thead>
            <tbody>
              {loading && <tr><td colSpan={6}><div className="empty-row">正在加载…</div></td></tr>}
              {!loading && items.length === 0 && <tr><td colSpan={6}><div className="empty-row">暂无操作记录</div></td></tr>}
              {items.map((item) => <tr key={item.id}>
                <td>{item.result === 'success' ? <span className="audit-result success"><CheckCircle2 size={16} />成功</span> : <span className="audit-result failed"><XCircle size={16} />失败</span>}</td>
                <td><strong>{item.action}</strong></td><td>{item.target}</td><td className="muted-cell">{item.detail || '—'}</td><td>{item.actor}</td><td className="nowrap">{new Date(item.createdAt).toLocaleString('zh-CN')}</td>
              </tr>)}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  )
}
